import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { getMypageNews, getMypageNewsList } from '@/api/mypageNewsEndpoint';
import { MypageNews } from '@/types';

export type MypageNewsInfo = {
  mypageNewsList?: MypageNews[];
  mypageNews?: MypageNews;
};

const module: Module<MypageNewsInfo, RootState> = {
  namespaced: true,
  state: {
    mypageNewsList: [],
    mypageNews:{
      newsId: '',
      newsTitle: '',
      newsText: '',
      dispdateFrom: ''
    }
  },
  getters: {
    mypageNewsInfo(state) {
      return state.mypageNews;
    },
    mypageNewsInfoList(state) {
      return state.mypageNewsList;
    }
  },

  mutations: {
    setMypageNews(state, value: MypageNews) {
      state.mypageNews = value;
    },
    setMypageNewsList(state, value: MypageNews[]) {
      state.mypageNewsList = value;
    }
  },

  actions: {
    async select({ commit }, { newsId }: { newsId: string }) {

      const res = await getMypageNews({
       newsId: newsId
      });
      if(res.data.detail != null) {
        commit('setMypageNews', res.data.detail[0]);
      }
    },
    async getList({ commit }) {

      const res = await getMypageNewsList();
      if(res.data.detail != null) {
        commit('setMypageNewsList', res.data.detail);
      }
    },
  },
};

export default module;
